export const messages = {
  en: {
    menuGroup: {
      fetchError: 'Fetch error'
    },
    menu: {
      fetchError: 'Fetch error'
    },
    menuManage: {
      queryCondition: 'Query Conditions',
      selectMerchantType: 'Select Merchant Type',
      pleaseSelect: 'Please Select',
      operationTeam: 'Operation Team',
      merchant: 'Merchant',
      devTeam: 'Development Team',
      selectMenuGroupName: 'Select Menu Group Name',
      select: 'Select',
      inputMenuName: 'Input Menu Name',
      inputPrivilegeName: 'Input Privilege Name',
      query: 'Query',
      reset: 'Reset',
      menuInfo: 'Menu Information',
      configMenu: 'Configure Menu',
      menuGroupId: 'Menu Group ID',
      menuGroupName: 'Menu Group Name',
      menuId: 'Menu ID',
      menuName: 'Menu Name',
      belongMerchant: 'Belong Merchant',
      menuUrl: 'Menu URL',
      sequence: 'Sequence',
      menuDisplay: 'Menu Display',
      operation: 'Operation',
      privilege: 'Privilege',
      edit: 'Edit',
      delete: 'Delete'
    },
    chooseMenuGroup: {
      selectMenuGroup: 'Select Menu Group',
      inputMenuGroupName: 'Input Menu Group Name',
      query: 'Query',
      groupId: 'Group ID',
      groupName: 'Group Name',
      icon: 'Icon',
      label: 'Label',
      belongMerchant: 'Belong Merchant',
      sequence: 'Sequence',
      description: 'Description',
      operation: 'Operation',
      select: 'Select',
      operationTeam: 'Operation Team',
      agent: 'Agent',
      logistics: 'Logistics Company',
      merchant: 'Merchant',
      devTeam: 'Development Team',
      runner: 'Runner',
      unknown: 'Unknown'
    },
    editMenu: {
      editMenu: 'Edit Menu',
      menuName: 'Menu Name',
      menuNamePlaceholder: 'Required, please enter menu name',
      menuUrl: 'Menu URL',
      menuUrlPlaceholder: 'Required, please enter menu URL',
      sequence: 'Sequence',
      sequencePlaceholder: 'Required, please enter sequence',
      menuDisplay: 'Menu Display',
      menuDisplayPlaceholder: 'Required, please select menu display',
      description: 'Description',
      descriptionPlaceholder: 'Optional, please enter description',
      showMenu: 'Show Menu',
      hideMenu: 'Hide Menu',
      cancel: 'Cancel',
      save: 'Save',
      menuNameRequired: 'Menu name cannot be empty',
      menuUrlRequired: 'Menu URL cannot be empty',
      sequenceRequired: 'Sequence cannot be empty',
      menuDisplayRequired: 'Menu display cannot be empty',
      menuIdRequired: 'Menu ID cannot be empty',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed'
    },
    deleteMenu: {
      confirmOperation: 'Please confirm your operation',
      confirmDeleteMenu: 'Confirm to delete menu?',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed'
    }
  },
  zh: {
    menuGroup: {
      fetchError: '获取数据失败'
    },
    menu: {
      fetchError: '获取数据失败'
    },
    menuManage: {
      queryCondition: '查询条件',
      selectMerchantType: '请选择商户类型',
      pleaseSelect: '请选择',
      operationTeam: '运营团队',
      merchant: '商家',
      devTeam: '开发团队',
      selectMenuGroupName: '请选择菜单组名称',
      select: '选择',
      inputMenuName: '请输入菜单名称',
      inputPrivilegeName: '请输入权限名称',
      query: '查询',
      reset: '重置',
      menuInfo: '菜单信息',
      configMenu: '配置菜单',
      menuGroupId: '菜单组ID',
      menuGroupName: '菜单组名称',
      menuId: '菜单ID',
      menuName: '菜单名称',
      belongMerchant: '归属商户',
      menuUrl: '菜单地址',
      sequence: '序列',
      menuDisplay: '菜单显示',
      operation: '操作',
      privilege: '权限',
      edit: '修改',
      delete: '删除'
    },
    chooseMenuGroup: {
      selectMenuGroup: '选择菜单组',
      inputMenuGroupName: '输入菜单组名称',
      query: '查询',
      groupId: '组ID',
      groupName: '组名称',
      icon: '图标',
      label: '标签',
      belongMerchant: '归属商户',
      sequence: '序列',
      description: '描述',
      operation: '操作',
      select: '选择',
      operationTeam: '运营团队',
      agent: '代理商',
      logistics: '物流公司',
      merchant: '商家',
      devTeam: '开发团队',
      runner: '跑腿',
      unknown: '未知'
    },
    editMenu: {
      editMenu: '修改菜单',
      menuName: '菜单名称',
      menuNamePlaceholder: '必填，请填写菜单名称',
      menuUrl: '菜单地址',
      menuUrlPlaceholder: '必填，请填写菜单地址',
      sequence: '序列',
      sequencePlaceholder: '必填，请填写序列',
      menuDisplay: '菜单显示',
      menuDisplayPlaceholder: '必填，请选择菜单显示',
      description: '描述',
      descriptionPlaceholder: '选填，请填写描述',
      showMenu: '显示菜单',
      hideMenu: '不显示菜单',
      cancel: '取消',
      save: '保存',
      menuNameRequired: '菜单名称不能为空',
      menuUrlRequired: '菜单地址不能为空',
      sequenceRequired: '序列不能为空',
      menuDisplayRequired: '菜单显示不能为空',
      menuIdRequired: '菜单ID不能为空',
      saveSuccess: '保存成功',
      saveFailed: '保存失败'
    },
    deleteMenu: {
      confirmOperation: '请确认您的操作',
      confirmDeleteMenu: '确定删除菜单？',
      cancel: '点错了',
      confirmDelete: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败'
    }
  }
}